import template from './rooms-for-sale-count.jade';

export default angular
  .module('cian.addForm.roomsForSaleCount', [])
  .directive('cianAfAboutObjectRoomsForSaleCount', () => ({
    scope: {},
    bindToController: {
      ad: '=',
      form: '=',
    },
    controller: [function () {}],
    controllerAs: 'roomsForSaleCount',
    template,
  })).name;
